// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_GcGUJ, .video_LnhMg {
    height: 100%;
    width: 100%;
}

.container_GcGUJ {
    position: relative;
    min-height: inherit;
}

.video_LnhMg {
    position: absolute;
    top: 0;
    left: 0;
}

.video_LnhMg, .scanArea_oW6g1 {
    object-fit: contain;
}

.scanArea_oW6g1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: contain;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-scanner-elements/lib/views/CodeScanner.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":[".container, .video {\n    height: 100%;\n    width: 100%;\n}\n\n.container {\n    position: relative;\n    min-height: inherit;\n}\n\n.video {\n    position: absolute;\n    top: 0;\n    left: 0;\n}\n\n.video, .scanArea {\n    object-fit: contain;\n}\n\n.scanArea {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_GcGUJ`,
	"video": `video_LnhMg`,
	"scanArea": `scanArea_oW6g1`
};
export default ___CSS_LOADER_EXPORT___;
